import { render, staticRenderFns } from "./getDiscount.vue?vue&type=template&id=549eee25&scoped=true&"
import script from "./getDiscount.vue?vue&type=script&lang=js&"
export * from "./getDiscount.vue?vue&type=script&lang=js&"
import style0 from "./getDiscount.vue?vue&type=style&index=0&id=549eee25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549eee25",
  null
  
)

export default component.exports